<template>
  <div class="orderResult">
    <OrderResultBlock ref="OrderResultBlock" class="mt-32" :order="order" @reFetch="getOrder" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import OrderResultBlock from '@/components/orderResultBlock'
export default {
  name: 'OrderResult',
  metaInfo () {
    return {
      title: '訂單結果'
    }
  },
  components: {
    OrderResultBlock
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      order: 'order/order'
    })
  },
  methods: {
    ...mapActions([
      'order/getOrder'
    ]),
    ...mapMutations([
      'order/CLEAR_CARTS',
      'order/CLEAR_ADDON_CARTS',
      'order/CLEAR_DATES',
      'order/SET_ORDER',
      'order/RESET_PAYMENT'
    ]),
    getOrder: function () {
      this['order/getOrder']().then(res => {
        if (res.status === 200) {
          this['order/RESET_PAYMENT']()
        }
        // this.$refs.OrderResultBlock.switchProcessingStatus(false)
      })
    }
  },
  created () {
    this.getOrder()
    this['order/CLEAR_CARTS']()
    this['order/CLEAR_ADDON_CARTS']()
    this['order/CLEAR_DATES']()
    this['order/SET_ORDER']({})
  }
}
</script>

<style lang="scss" scoped>

</style>
